export function getTermsAndConditions() {
  return (
    <>
      <div style={{ maxWidth: "742px" }}>
        <p style={{ paddingTop: "20px" }}>
          Registreerudes internetilehekülje turgoil.com kasutajaks, kinnitad, et
          oled tutvunud käesoleva kasutajalepingu tingimustega (edaspidi
          Kasutustingimused), nõustud Kasutustingimustega ning kohustud
          Kasutustingimusi täitma alljärgnevas:
        </p>
        <div className="termsAndConditions">
          <ol>
            <li>
              ÜLDSÄTTED
              <ol>
                <li>
                  Käesolevad Kasutustingimused reguleerivad õigussuhteid, mis
                  tekivad turgoil.com keskkonna kasutamisel.
                </li>
                <li>
                  Kasutustingimustes kasutatakse mõisteid alljärgnevas
                  tähenduses:
                  <ol>
                    <li>
                      Turgoil.com - internetiaadressil turgoil.com asuv teenuste
                      osutamise keskkond;
                    </li>
                    <li>
                      Kasutajakonto - turgoil.com kasutajaks registreeritud
                      isiku kasutajatunnus koos salasõnaga;
                    </li>
                    <li>
                      Kasutaja - isik, kellel on turgoil.com kasutajakonto;
                    </li>
                    <li>
                      Hanke korraldaja – kasutaja, kes on turgoil.com keskkonda
                      lisanud hanke;
                    </li>
                    <li>
                      Pakkuja – kasutaja, kes on teinud pakkumise turgoil.com
                      keskkonnas olevale hankele;
                    </li>
                    <li>
                      Mittelepinguline pakkuja - kasutaja, kellel puudub kehtiv
                      leping platvormiga, kuid kes osaleb siiski konkreetsetel
                      hangetel, kuhu hankija on teda kutsunud.
                    </li>
                    <li>
                      Hanke võitja – kasutaja, kes on Hanke korraldaja poolt
                      määratud hanke võitjaks;
                    </li>
                    <li>
                      Hanke luhtumine – situatsioon, kus peale Hanke võitja
                      valikut Hanke korraldaja ja Hanke võitja ei saavuta
                      omavahel kokkulepet ning hange jääb teostamata;
                    </li>
                    <li>
                      Testperiood – ajavahemik, mille jooksul platvormi või
                      hankemenetluse toimimist katsetatakse; testperioodi kestus
                      on kuni viis (5) hanget või kuni 3 kuud alates
                      Kasutajakonto loomisest (olenevalt kumb saabub varem).
                      Testperioodil osalemine ei too kaasa hankija kohustust
                      valida võitjat ega rakendada hankija seatud nõudeid hanke
                      võitja valimiseks.
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li>
              KASUTAJALEPINGU SISU
              <ol>
                <li>
                  Turgoil OÜ poolt turgoil.com keskkonnas osutatava teenuse
                  sisuks on Kasutajale hanke kuulutuse avaldamise ja/või
                  pakkumise tegemise võimaluse loomine Kasutustingimustes
                  sätestatud tingimustel. Turgoil OÜ ei tegele vedelkütuse
                  müügiga, ega ole lepingu pooleks õigussuhtes, mis tekib Hanke
                  korraldaja ja Hanke võitja vahel.
                </li>
                <li>
                  Turgoil.com keskkonnas võib avaldada üksnes selliseid
                  kuulutusi ja informatsiooni, mis pole seaduse või
                  Kasutajatingimustega keelatud.
                </li>
              </ol>
            </li>
            <li>
              TURGOIL.COM ÕIGUSED JA KOHUSTUSED
              <ol>
                <li>
                  Turgoil.com-l on õigus:
                  <ol>
                    <li>
                      kontrollida, et keskkonna kasutamine toimuks kooskõlas
                      Kasutustingimustega. Rikkumise avastamisel võib
                      turgoil.com kasutada kõiki seaduses ja käesolevates
                      Kasutustingimustes sätestatud õigusi.
                    </li>
                    <li>
                      nõuda Kasutajakonto loomisel isiku autentimist ja töödelda
                      teenuste osutamise eesmärgil isikuandmeid seaduses
                      sätestatud tingimustel ja korras;
                    </li>
                    <li>
                      tutvuda talle sobival ajal Kasutaja poolt avalikkusele
                      kättesaadavaks tehtud materjalidega kontrollimaks, kas
                      nimetatud materjalid pole vastuolus Kasutustingimustes
                      sätestatuga.
                    </li>
                    <li>
                      kuvada pakkujatele hanke korraldaja andmeid (eesnimi ja
                      perenimi) juhul kui on tegemist eraisiku hankega;
                    </li>
                    <li>
                      saata Hanke võitjale andmed (kontaktandmed) Hanke
                      korraldaja kohta;
                    </li>
                    <li>
                      saata Hanke korraldajale andmed (kontaktandmed) Hanke
                      võitja kohta;
                    </li>
                    <li>
                      küsida Hanke korraldajalt ja/või Hanke võitjalt põhjendusi
                      selle kohta, miks jäi teostamata kuulutuses kirjeldatud
                      hange.
                    </li>
                    <li>
                      blokeerida seaduse ja Kasutustingimuste vastaselt käituva
                      Kasutaja Kasutajakonto;
                    </li>
                    <li>
                      küsida Kasutajalt Kasutajakonto blokeerimise lõpetamise
                      eest tasu;
                    </li>
                    <li>
                      rakendada rahalisi meetmeid Kasutaja suhtes, kui selgub,
                      et on rikutud Kasutustingimustes ja/või lepingutes
                      kirjeldatud nõudeid ja/või reegleid. Rahalised meetmed
                      võivad hõlmata leppetrahvi või muid lepingulisi meetmeid,
                      mille suurus ja ulatus määratakse rikkumise tõsiduse
                      alusel;
                    </li>
                    <li>
                      arvestada maha hanke tasu Kasutustingimustes toodud
                      tingimustel üksnes juhul, kui hange on tunnistatud
                      luhtunuks objektiivsel põhjusel;
                    </li>
                    <li>
                      tingimusteta ja viivitamatult peatada teenuste kasutamise
                      võimalus (Kasutaja blokeerida) juhul, kui Kasutaja eirab
                      Kasutustingimusi või turgoil.com-l on põhjendatud kahtlus,
                      et Kasutaja võib neid eirata;
                    </li>
                    <li>
                      portaalil (turgoil.com) on õigus ajutiselt peatada või
                      lõplikult lõpetada hanke korraldaja või tema esindaja
                      kasutajakonto kasutamine, kui portaali valduses olevate
                      andmete (sh krediidiinfo, maksekäitumise raportite või
                      muude avalike allikate) alusel ilmnevad märkimisväärsed
                      probleemid maksekäitumises, krediidiskooris või
                      varasemates võlgnevustes.
                    </li>
                  </ol>
                </li>
                <li>
                  Turgoil.com-l on kohustus:
                  <ol>
                    <li>
                      hooldada ning jälgida teenuste toimimist ja nende
                      Kasutajale kättesaadavust;
                    </li>
                    <li>
                      tagada Kasutaja abistamiseks klienditoe toimimine e-posti
                      aadressil info@turgoil.com;
                    </li>
                    <li>
                      esitada Hanke võitjale andmed Hanke korraldaja kohta;
                    </li>
                    <li>
                      esitada Hanke korraldajale andmed Hanke võitja kohta;
                    </li>
                    <li>blokeerida Kasutaja avalduse alusel Kasutajakonto.</li>
                  </ol>
                </li>
              </ol>
            </li>
            <li>
              PIIRANGUD TURGOIL.COM TEENUSTE KASUTAMISEL
              <ol>
                <li>
                  turgoil.com teenuste kasutamine Eesti Vabariigi seadusandluse
                  ning heade tavade ja kommetega vastuolus oleva, sündsusetu või
                  muul viisil sobimatu teo tegemiseks või selle propageerimiseks
                  on keelatud.
                </li>
                <li>
                  Sealhulgas, kuid mitte ainult, on turgoil.com teenuste
                  kasutamisel keelatud alljärgnevalt loetletud teod:
                  <ol>
                    <li>
                      juurdepääsu tekitamine internetivõrgus olevatele
                      sellistele ressurssidele, millele juurdepääs ei ole
                      Kasutajale lubatud;
                    </li>
                    <li>
                      autoriõigusega kaitstavate teoste, kaubamärkide, ärinime,
                      reklaami, litsentside, tööstusdisaini vms
                      intellektuaalomandi kasutamine, mille kasutamine ei ole
                      antud Kasutajal lubatud, või viisil, kuidas ei ole
                      lubatud;
                    </li>
                    <li>
                      arvutitehnika abil koostatud või kogutud andmete
                      terviklikkuse omavoliline hävitamine, kahjustamine või
                      muutmine;
                    </li>
                    <li>
                      selliste andmete ja materjalide kopeerimine või mistahes
                      viisil edastamine, mis tekitavad teenusserveritele
                      ebanormaalset koormust;
                    </li>
                    <li>
                      arvutiviiruste või programmide, mis sisaldavad endas
                      viirusi või mistahes muid koode, faile või programme
                      ja/või selle osasid, mis on loodud segama, häirima või
                      piirama telekommunikatsioonivõrgu, selle seadmete või
                      kasutatava tarkvara funktsionaalsust, mistahes viisil
                      levitamine;
                    </li>
                    <li>
                      julmuse, füüsilise või psüühilise vägivalla ning
                      ebaseadusliku tegevuse propageerimine;
                    </li>
                    <li>
                      kas otseselt või kaudselt teistele Internetivõrgus
                      olevatele materjalidele viitamine, Kasutaja enda või mõne
                      muu isiku reklaamimine, välja arvatud juhul, kui see on
                      lubatud käesolevates Kasutustingimustes;
                    </li>
                    <li>
                      turgoil.com teenuseid kasutades Internetivõrgu töö või
                      teiste Kasutajate häirimine;
                    </li>
                    <li>
                      turgoil.com keskkonda libapakkumiste ja/või libahangete
                      sisestamine;
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li>
              KASUTAJA ÕIGUSED JA KOHUSTUSED
              <ol>
                <li>
                  Kasutaja õigused ja kohustused
                  <ol>
                    Kasutajal on õigus:
                    <li>
                      saada kõiki turgoil.com platvormi pakutavaid teenuseid
                      vastavalt kehtivatele kasutustingimustele;
                    </li>
                    Kasutaja on kohustatud:
                    <li>
                      esitama turgoil.com kasutajaks registreerumisel tõeseid
                      isikuandmeid, sh registreerida oma õige ja täieliku nime
                      all ning kasutada kehtivat e-posti aadressi;
                    </li>
                    <li>
                      mitte kasutama turgoil.com keskkonda ebaseaduslikeks
                      tehingu(te)ks ja/või pettus(t)eks;
                    </li>
                  </ol>
                </li>
                <li>
                  Hanke Korraldaja õigused ja kohustused:
                  <ol>
                    Hanke korraldajal on õigus:
                    <br />
                    <li>
                      saada portaali kaudu pakkumisi ja valida neist sobivaim;
                    </li>
                    <li>
                      saada täielikku ja täpset teavet kõikide hanke tingimuste
                      ja nõuete kohta, sealhulgas hinnapakkumiste, tootelalaste
                      nõuete ja parameetrite ning hindamiskriteeriumide osas, et
                      teha teadlikke otsuseid.
                    </li>
                    <li>
                      kutsuda hankesse osalema portaalisiseseid mittelepingulisi
                      pakkujaid, eesmärgiga laiendada potentsiaalsete pakkujate
                      ringi ning seeläbi soodustada konkurentsi ja kvaliteetsete
                      pakkumiste laekumist.
                    </li>
                    <li>
                      pöörduda platvormi omaniku poole, kui mittelepinguliste
                      pakkujatega esineb korduvaid probleeme, kes võib olukorra
                      hindamise tulemusel võtta tarvitusele meetmeid, sealhulgas
                      mittelepingulise pakkuja eemaldamise platvormilt.
                    </li>
                    Hanke korraldaja on kohustatud:
                    <br />
                    <li>
                      tagama, et hankemenetluse käigus ei võetaks paralleelseid
                      portaaliväliseid pakkumisi nii portaali lepingulistelt kui
                      ka mittelepingulistelt pakkujatelt. Kõik pakkumised peavad
                      toimuma portaali kaudu, et tagada läbipaistvus ja õiglased
                      konkurentsitingimused;
                    </li>
                    <li>
                      tagama, et hanketingimuste hindu ei avaldata teistele
                      turuosalistest pakkujatele, sealhulgas neile, kes ei ole
                      portaali kasutajad. Hanketingimuste hinnad ja muud seotud
                      konfidentsiaalsed andmed on mõeldud ainult hankeprotsessis
                      osalejatele ja nende avaldamine võib kahjustada hanke
                      ausust ja konkurentsi;
                    </li>
                    <li>
                      andma süsteemis kirjalikku tagasisidet iga korraldatud
                      hanke kohta, juhul kui hanke võitjat ei õnnestu valida,
                      välja arvatud testperioodil. See nõue kehtib, kui hankele
                      on tehtud <b>vähemalt üks või enam pakkumist</b>. Kui
                      hanke võitjat ei valita ja portaali haldaja leiab, et
                      puudub piisav põhjendus või see on vastuolus
                      Kasutajatingimustega, on portaali haldajal õigus nõuda
                      tasu, mis moodustab 2-5 % hanke lõpphinnast, sõltuvalt
                      puuduse astmest, kuid mitte vähem kui 50 eurot:
                      <ol>
                        <li>
                          2 % tasu: kui on esitatud osaline või ebaselge
                          kirjalik põhjendus, ning puudus on esmakordne;
                        </li>
                        <li>
                          3 % tasu: kui kirjalik põhjendus on ebapiisav, ning
                          see põhjustab väiksemaid häireid hankeprotsessis, kuid
                          hankija on võtnud kasutusele mõningaid
                          parandusmeetmeid;
                        </li>
                        <li>
                          4 % tasu: kui kirjalik põhjendus puudub täielikult,
                          ning tekitab märkimisväärseid probleeme platvormi
                          toimimises;
                        </li>
                        <li>
                          5% tasu: kui kirjalik põhjendus puudub täielikult,
                          rikkumine on korduv ja see põhjustab ulatuslikke
                          kahjusid ning tõsiselt häirib kogu hankeprotsessi;
                        </li>
                      </ol>
                    </li>
                    <li>
                      andma turgoil.com`le 5 (viie) päeva jooksul tagasisidet
                      kõikidest põhjustest, miks Hanke korraldaja arvates ei ole
                      võimalik Hanke võitjaga saavutada kokkulepet Hanke
                      korraldaja poolt kuulutuses avaldatud töö teostamiseks,
                      kui turgoil.com temaga kontakteerub kas e-posti või
                      telefoni teel;
                    </li>
                    <li>
                      sõlmima vajadusel tarnelepingu ja tagama hanke võitnud
                      pakkujaga tarnetingimuste täitmise. See hõlmab
                      lepingutingimuste elluviimist ja koostööd, et tagada
                      tarnete tähtaegne ja kvaliteetne täitmine vastavalt hanke
                      tingimustele.
                    </li>
                    <li>
                      tagama, et mittelepingulised pakkujad vastaksid nende
                      seatud kvaliteedi- ja sobivuskriteeriumitele, tagades
                      sellega, et iga pakkumine vastab hankija vajadustele ja
                      standarditele.
                    </li>
                    <li>
                      jälgima, et mittelepingulised pakkujad täidaksid kõiki
                      hankega seotud nõudeid ja tingimusi.
                    </li>
                    <li>
                      kaebuste ja vaidluste tekkimisel mittelepingulise
                      pakkujaga ise aktiivselt sekkuma ja lahendama olukorda
                      vastavalt kehtivatele regulatsioonidele ning parimatele
                      tavadele. See sisaldab vajalike sammude astumist, et
                      tagada aus ja õiglane menetlus kõigi osapoolte suhtes.
                    </li>
                  </ol>
                </li>
                <li>
                  Mittelepinguliste pakkujate õigused ja kohustused:
                  <ol>
                    Mittelepingulistel pakkujatel on õigus:
                    <li>
                      esitada pakkumisi hangetele, kus neid on kutsutud.
                      Mittelepinguline pakkuja võib osaleda ainult neil
                      hangetel, millel on selgesõnaliselt ette nähtud nende
                      osalemine.
                    </li>
                    Mittelepingulised pakkujad on kohustatud:
                    <li>
                      tasuma vahendustasu vastavalt järgmisele
                      hinnastusmudelile:
                      <ol>
                        <li>1000–4999 liitrit: 0,002 €/liiter;</li>
                        <li>alates 5000 liitrist: 0,0015 €/liiter.</li>
                      </ol>
                      Tasu tuleb tasuda platvormi poolt määratud tähtaja
                      jooksul. Tasumata vahendustasu korral jätab platvorm
                      endale õiguse peatada või lõpetada koostöö
                      mittelepingulise pakkujaga vastavalt eemaldamise korrale
                      (vt punkt 3.1.8).
                    </li>
                    <li>
                      tarnima kütuse vastavalt hankes määratud tingimustele.
                      Tarnete täpsus, kvaliteet, kogused ja tähtajad peavad
                      vastama hanke dokumentatsioonis sätestatule. Kõik tarned
                      peavad vastama seadusandlikele ja regulatiivsetele
                      nõuetele.
                    </li>
                    <li>
                      tagama, et hankemenetluse käigus ei tehtaks otsepakkumisi
                      hanke korraldajaga ega võetakse ühendust väljaspool
                      platvormi. Kõik pakkumised ja suhtlus peavad toimuma
                      platvormi vahendusel, et tagada protsessi läbipaistvus ja
                      kõigi osapoolte võrdne kohtlemine. Keelu rikkumise korral
                      jätab platvorm endale õiguse rakendada sanktsioone,
                      sealhulgas mittelepingulise pakkuja eemaldamist
                      platvormilt.
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li>
              HANKE LUHTUMINE
              <ol>
                <li>
                  Hanke võitja võib esitada turgoil.com e-postile
                  info@turgoil.com avalduse hanke luhtunuks tunnistamiseks, kui
                  Hanke võitja ei ole Hanke korraldajaga saavutanud 5 (viie)
                  päeva jooksul kokkulepet, mille esemeks on turgoil.com-s
                  avaldatud hange. Turgoil.com-le esitatavas avalduses tuleb
                  Hanke võitjal esitada kõik Hanke luhtumise põhjused.
                </li>
                <li>
                  Hanke luhtunuks tunnistamise menetluses kontrollib turgoil.com
                  Hanke võitja poolt hanke luhtumise kohta esitatud põhjendusi
                  ja teeb nende põhjal otsuse. Turgoil.com-l on õigus küsida
                  Hanke võitjalt täiendavat informatsiooni hanke luhtunuks
                  tunnistamise avalduses esitatud põhjenduste kohta.
                </li>
                <li>
                  Hanke luhtunuks tunnistamisel sisaldub hange Pakkuja arves
                  juhul kui:
                  <ol>
                    <li>
                      Pärast võitja välja kuulutamist ei ole Hanke võitja Hanke
                      korraldajaga kontakteerunud 5 (viie) päeva jooksul.
                    </li>
                    <li>
                      Hanke luhtumise põhjuseks ei ole objektiivne asjaolu.
                      Objektiivse asjaoluna käsitleb turgoil.com sellist
                      asjaolu, mida Hanke võitja ja/või Hanke korraldaja ei
                      saanud oma käitumisega mõjutada;
                    </li>
                    <li>
                      Hanke võitja ei ole esitanud - turgoil.com-le hanke
                      luhtunuks tunnistamise kohta täiendavat informatsiooni 5
                      (viie) päeva jooksul arvates turgoil.com poolt vastava
                      kirja saatmisest Hanke võitja e-postile.
                    </li>
                    <li>
                      Hanke võitja poolt esitatud pakkumine on turgoil.com
                      reeglitega vastuolus.
                    </li>
                  </ol>
                </li>
                <li>
                  Turgoil.com teavitab Hanke võitjat kirjalikult e-posti teel
                  Hanke luhtunuks tunnistamisest juhul kui hange on luhtunud
                  siis see ei kajastu arves, kusjuures otsus on lõplik.
                </li>
                <li>
                  Hanke luhtunuks tunnistamisel seoses objektiivse asjaolu
                  esinemisega ei kajastu see arve arves.
                </li>
              </ol>
            </li>
            <li>
              VASTUTUS
              <ol>
                Turgoil.com vastutab:
                <li>
                  kasutustingimustes nimetatud kohustuste täitmise eest antud
                  ajahetkel parimal võimalikul viisil, kusjuures turgoil.com ei
                  võta endale mistahes vastutust seoses Kasutaja võimalike
                  kahjudega alljärgnevatel juhtudel:
                  <ol>
                    <li>
                      kui kahju on tekkinud - turgoil.com-st mitteolenevatel
                      põhjustel, eelkõige häiretest teenuste osutamisel või
                      teenuste kasutamise eeldusena toimivas internetiühenduses;
                    </li>
                    <li>
                      kui kahju on tekkinud - turgoil.com-st mitteolenevatel
                      põhjustel kasutaja informatsiooni edastamisviivituse või
                      mahakustutamise tulemusena;
                    </li>
                    <li>
                      kui kahju on tekkinud volitamata isikute juurdepääsu
                      tulemusena Internetivõrgus asuvale informatsioonile või
                      sellise informatsiooni muutmisel selleks volitamata
                      isikute poolt;
                    </li>
                    <li>
                      kui Kasutajal on pretensioone teenuste kaudu või nendega
                      seoses esitatava või saadava informatsiooni, teenuste või
                      toodete kättesaadavuse, oma eesmärkidele sobivuse, nende
                      tõesuse ja/või sisu suhtes.
                    </li>
                  </ol>
                </li>
                Turgoil.com ei vastuta:
                <li>
                  hankijate ja mittelepinguliste pakkujate vahel tekkivate
                  vaidluste ega tarnete puuduste eest. Hankija vastutab
                  täielikult mittelepinguliste pakkujatega seotud kvaliteedi,
                  tarnete ja kasutajatingumuste järgimise eest.
                  <ol>
                    <li>
                      sealhulgas ühegi otsese ega kaudse kahju eest, mis tuleneb
                      mittelepinguliste pakkujate kohustuste rikkumisest,
                      sealhulgas, kuid mitte ainult, kvaliteediprobleemidest,
                      viivitustest või tarnete puudumisest.
                    </li>
                  </ol>
                </li>
                <li>
                  Kasutaja vastutab muuhulgas iseseisvalt ja täielikult:
                  <ol>
                    <li>
                      tema poolt teenuste kasutamisel edastatavate andmete ja
                      informatsiooni sisu eest ning nende vastavuse eest
                      Kasutustingimustes ja kehtivas seadusandluses sätestatuga;
                    </li>
                    <li>
                      teenuste kasutamise eesmärkide kuritarvitamise eest;
                    </li>
                    <li>
                      kahjude eest, mis tekivad Kasutajale endale ja/või
                      mistahes kolmandale isikule seoses käesolevate
                      Kasutustingimuste rikkumisega Kasutaja poolt.
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li>
              INTELLEKTUAALOMAND
              <ol>
                <li>
                  Platvormi omandiõigus
                  <ol>
                    <li>
                      Turgoil ja tema litsentsiandjad säilitavad kõik
                      intellektuaalomandi õigused platvormile ja selle sisule.
                    </li>
                    <li>
                      Ilma, et see piiraks käesolevate tingimuste konkreetsemaid
                      sätteid, kuuluvad sinna intellektuaalomandi õigused,
                      andmebaasiõigused, disainiomandid, kataloogimise õigused,
                      kaubamärgiomandid, patendiõigused. Sealhulgas kuuluvad
                      ainuõiguslikult Turgoilie või tema litsentsiandjatele
                      algoritmid, kood, kontseptsioon (sh funktsioonide ja
                      elementide struktuur), andmed, disain, kirjeldused,
                      joonised, võrrandid, valemid, graafika, know-how, märgid,
                      objektid, objektikood, pildid, fotod, protsessid,
                      esitlused, kviitungid, skeemid, lähtekood, tehnilised
                      lahendused. Kasutajad ei tohi kopeerida, muuta ega
                      levitada ühtegi osa platvormist või selle sisust ilma
                      Turgoili kirjaliku loata.
                    </li>
                    <li>
                      Kõik kaubamärgid, nominaalsed või kujundlikud ja kõik muud
                      märgid sh. kaubanimetused, teenusmärgid, sõnamärgid,
                      illustratsioonid, pildid või logod, mis ilmuvad seoses
                      selle platvormiga, on ja jäävad ainuõiguslikult Turgoili
                      või tema litsentsiandjate omandiks ning alluvad
                      intellektuaalomandi kohta kehtivatele seadustele või
                      rahvusvahelistele lepetele.
                    </li>
                  </ol>
                </li>
              </ol>
            </li>
            <li>
              KASUTAMISTINGIMUSTE KEHTIVUS JA MUUTMINE
              <ol>
                <li>
                  Kasutustingimused jõustuvad turgoil.com keskkonda
                  Kasutajakonto loomisest alates ja kehtivad tähtajatult.
                </li>
                <li>
                  Turgoil.com-l on õigus ilma Kasutajale ette teatamata muuta
                  ja/või modifitseerida teenuste sisu, parameetreid, piiranguid,
                  protseduure, teenuste osutamise menüüstruktuure,
                  dokumentatsiooni jms. Muudatused loetakse kasutajale teatavaks
                  tehtuks alates nende paigutamise hetkest turgoil.com
                  keskkonda.
                </li>
                <li>
                  Turgoil.com-l on õigus teenuste arengust tulenevalt ning nende
                  parema ja turvalisema kasutamise huvides Kasutustingimusi ja
                  hinnakirja ühepoolselt muuta ning täiendada.
                </li>
                <li>
                  Turgoil.com võib teavitada Kasutajat Kasutustingimuste ja
                  hinnakirja muudatustest ja täiendustest turgoil.com-s
                  avaldatavate vastavate teadete kaudu.
                </li>
                <li>
                  Kasutustingimuste ja hinnakirja muudatused ning täiendused
                  jõustuvad vastava muudatuse või täienduse avaldamisest
                  turgoil.com.
                </li>
                <li>
                  Kasutaja kinnitab oma nõustumisest muudatuste ja täiendustega
                  hinnakirjas ja/või Kasutustingimustes turgoil.com teenuste
                  kasutamisega peale vastavate muudatuste/täienduste jõustumist.
                </li>
              </ol>
            </li>
            <li>
              LÕPPSÄTTED
              <ol>
                <li>
                  Turgoil.com kasutamisest tekkinud vaidlusi püüavad Kasutaja ja
                  turgoil.com lahendada läbirääkimiste teel. Kokkuleppe
                  mittesaavutamisel lahendab vaidluse Tartu Maakohus.
                </li>
                <li>
                  Kasutustingimused kehtivad nende aktsepteerimisel kasutaja
                  poolt ja kehtivad Kasutaja ja turgoil.com vaheliste
                  Kasutustingimustes reguleeritud õigussuhete kehtivuse ajal.
                  Kasutajal igal ajal õigus turgoil.com kasutajaleping üles
                  öelda, täites eelnevalt temal lasuvad kehtivad kohustused
                  turgoil.com ja teiste Kasutajate ees.
                </li>
              </ol>
            </li>
          </ol>
        </div>
      </div>
    </>
  );
}
